(function () {
  var mount = document.getElementById("nuvra-seller-shops-mount");
  if (!mount) return;

  var section = mount.closest("[data-api-base]");
  var STRIP_LAYOUT =
    Boolean(section) &&
    (section.classList.contains("nuvra-creators--strip") ||
      section.getAttribute("data-layout") === "strip");
  var API_BASE = (section && section.dataset.apiBase ? section.dataset.apiBase : "").replace(
    /\/$/,
    ""
  );
  var FALLBACK_API_BASE = "https://admin-uploader-psi.vercel.app";

  function resolveHeaderApiBase() {
    var wrap = document.querySelector(".nuvra-site-header-wrap");
    if (!wrap || !wrap.dataset.sellerApi) return FALLBACK_API_BASE;
    var apiBase = wrap.dataset.sellerApi.replace(/\/$/, "");
    if (!apiBase) return FALLBACK_API_BASE;
    if (
      apiBase.indexOf("studio.nuvrasupplyco.com") !== -1 ||
      apiBase.indexOf("nuvra-studio.vercel.app") !== -1
    ) {
      return FALLBACK_API_BASE;
    }
    return apiBase;
  }

  function uniqueApiBases() {
    var seen = {};
    return [API_BASE, resolveHeaderApiBase(), FALLBACK_API_BASE].filter(function (base) {
      if (!base || seen[base]) return false;
      seen[base] = true;
      return true;
    });
  }

  var FALLBACK_SEED_SHOPS = [
    {
      handle: "based-printed",
      shopName: "Based & Printed",
      bio: "Politically incorrect parody. Lawyers hate us. Customers love us.",
      listingCount: 42,
      totalSales: 3100,
      shopUrl: "/collections/libtards?view=creator-shop",
      createdAt: "2024-01-01T00:00:00.000Z",
      isSeed: true,
    },
    {
      handle: "cursed-cotton",
      shopName: "Cursed Cotton Club",
      bio: "Meme-tier chaos and zero-filter roasts. Touch grass? We printed that too.",
      listingCount: 27,
      totalSales: 1600,
      shopUrl: "/collections/dirty-humor-shits?view=creator-shop",
      createdAt: "2024-02-01T00:00:00.000Z",
      isSeed: true,
    },
    {
      handle: "iron-temple",
      shopName: "Iron Temple Tees",
      bio: "Gym psychological warfare. PRs and roasts on premium cotton.",
      listingCount: 18,
      totalSales: 890,
      shopUrl: "/collections/pure-chaos-tees?view=creator-shop",
      createdAt: "2024-03-01T00:00:00.000Z",
      isSeed: true,
    },
  ];

  function readSeedShops() {
    var node = document.getElementById("nuvra-seller-shop-seeds");
    if (!node || !node.textContent) return readDomSeedShops();

    try {
      var parsed = JSON.parse(node.textContent);
      if (Array.isArray(parsed) && parsed.length) return parsed;
    } catch (err) {
      /* use fallback */
    }

    return readDomSeedShops();
  }

  function readDomSeedShops() {
    var cards = mount.querySelectorAll("[data-seller-handle]");
    if (!cards.length) return FALLBACK_SEED_SHOPS;

    return Array.prototype.map.call(cards, function (card) {
      var img = card.querySelector(".nuvra-listing__img, .nuvra-creator-shop__banner img");
      var nameNode = card.querySelector(".nuvra-listing__title a, .nuvra-creator-shop__name");
      var bioNode = card.querySelector(".nuvra-creator-shop__bio");
      var link = card.querySelector("a[href]");

      return {
        handle: card.getAttribute("data-seller-handle") || "",
        shopName: nameNode ? nameNode.textContent.trim() : "",
        bio: bioNode ? bioNode.textContent.trim() : "",
        listingCount: parseInt(card.getAttribute("data-listing-count") || "0", 10) || 0,
        totalSales: parseInt(card.getAttribute("data-total-sales") || "0", 10) || 0,
        shopUrl: link ? link.getAttribute("href") : "#",
        createdAt: "2024-01-01T00:00:00.000Z",
        isSeed: true,
        bannerImageUrl: img ? img.getAttribute("src") : null,
      };
    });
  }

  var SEED_SHOPS = readSeedShops();

  function esc(str) {
    var d = document.createElement("div");
    d.textContent = str == null ? "" : String(str);
    return d.innerHTML;
  }

  function listingLabel(count) {
    if (count === 1) return "1 listing";
    return count + " listings";
  }

  function salesLabel(count) {
    if (!count) return "0 sales";
    if (count === 1) return "1 sale";
    return count + " sales";
  }

  function sortShops(shops) {
    return shops.slice().sort(function (a, b) {
      var salesA = a.totalSales || 0;
      var salesB = b.totalSales || 0;
      if (salesB !== salesA) return salesB - salesA;
      var listingsA = a.listingCount || 0;
      var listingsB = b.listingCount || 0;
      if (listingsB !== listingsA) return listingsB - listingsA;
      return new Date(b.createdAt || 0).getTime() - new Date(a.createdAt || 0).getTime();
    });
  }

  function mergeShops(apiShops) {
    var byHandle = {};
    var merged = [];

    SEED_SHOPS.forEach(function (shop) {
      byHandle[shop.handle] = true;
      merged.push(shop);
    });

    (apiShops || []).forEach(function (shop) {
      if (!shop || !shop.handle || byHandle[shop.handle]) return;
      byHandle[shop.handle] = true;
      merged.push(shop);
    });

    return sortShops(merged);
  }

  function removeLoopClones() {
    var track = mount.closest("[data-nuvra-seller-shops-track]") || mount;
    if (!track) return;
    track.querySelectorAll("[data-nuvra-seller-shops-clone]").forEach(function (node) {
      node.remove();
    });
  }

  function showSellerShops() {
    if (!section) return;
    section.querySelectorAll(".nuvra-reveal").forEach(function (el) {
      el.classList.add("is-visible");
    });
  }

  function renderShopCard(shop) {
    var initial = (shop.shopName || shop.handle || "?").slice(0, 1).toUpperCase();
    var bannerImage = shop.bannerImageUrl || shop.bannerUrl || "";
    var bannerHtml = bannerImage
      ? '<img src="' +
        esc(bannerImage) +
        '" alt="' +
        esc(shop.shopName || shop.handle || "Shop") +
        '" class="nuvra-listing__img" loading="lazy" decoding="async" width="600" height="750">'
      : "";

    if (STRIP_LAYOUT) {
      return (
        '<div class="nuvra-scroll-item">' +
        '<article class="nuvra-listing nuvra-listing--shop-spotlight nuvra-reveal is-visible" data-seller-handle="' +
        esc(shop.handle) +
        '">' +
        '<div class="nuvra-listing__media">' +
        '<a href="' +
        esc(shop.shopUrl) +
        '" class="nuvra-listing__img-link">' +
        bannerHtml +
        "</a></div>" +
        '<div class="nuvra-listing__body">' +
        '<h3 class="nuvra-listing__title"><a href="' +
        esc(shop.shopUrl) +
        '">' +
        esc(shop.shopName) +
        "</a></h3>" +
        "</div></article></div>"
      );
    }

    var bio =
      shop.bio || "New seller on Nuvra — customize your shop to tell your story.";
    var meta =
      "@" +
      esc(shop.handle) +
      " · " +
      esc(listingLabel(shop.listingCount || 0)) +
      " · " +
      esc(salesLabel(shop.totalSales || 0));

    return (
      '<a href="' +
      esc(shop.shopUrl) +
      '" class="nuvra-creator-shop nuvra-reveal">' +
      '<div class="nuvra-creator-shop__banner">' +
      bannerHtml +
      '<span class="nuvra-creator-shop__avatar">' +
      esc(initial) +
      "</span></div>" +
      '<div class="nuvra-creator-shop__body">' +
      '<h3 class="nuvra-creator-shop__name">' +
      esc(shop.shopName) +
      "</h3>" +
      '<p class="nuvra-creator-shop__meta">' +
      meta +
      "</p>" +
      '<p class="nuvra-creator-shop__bio">' +
      esc(bio) +
      "</p>" +
      '<span class="nuvra-creator-shop__visit">Visit Shop →</span>' +
      "</div></a>"
    );
  }

  function renderShops(shops) {
    var sorted = sortShops(shops || []);
    if (!sorted.length) {
      mount.innerHTML =
        '<div class="nuvra-seller-shops-empty"><p>No seller shops to show yet. Check back soon.</p></div>';
      removeLoopClones();
      return;
    }
    mount.innerHTML = sorted.map(renderShopCard).join("");
    removeLoopClones();
    showSellerShops();
  }

  window.nuvraInitSellerShopsLoop = function () {
    removeLoopClones();
    showSellerShops();
  };

  showSellerShops();

  if (!API_BASE) {
    renderShops(SEED_SHOPS);
    return;
  }

  function fetchShopsFromBase(base) {
    return fetch(base + "/api/seller/shops", { credentials: "omit" }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.error || "Could not load shops");
        return data;
      });
    });
  }

  function fetchShopsWithFallback(index, bases) {
    if (index >= bases.length) {
      return Promise.reject(new Error("Could not load shops"));
    }

    return fetchShopsFromBase(bases[index]).catch(function () {
      return fetchShopsWithFallback(index + 1, bases);
    });
  }

  fetchShopsWithFallback(0, uniqueApiBases())
    .then(function (data) {
      var apiShops = data.shops || [];
      var seedByHandle = {};

      SEED_SHOPS.forEach(function (shop) {
        seedByHandle[shop.handle] = shop;
      });

      apiShops = apiShops.map(function (shop) {
        var seed = seedByHandle[shop.handle];
        if (!seed || seed.bannerImageUrl) return shop;
        if (!shop.bannerImageUrl && seed.bannerImageUrl) {
          return Object.assign({}, shop, { bannerImageUrl: seed.bannerImageUrl });
        }
        return shop;
      });

      renderShops(mergeShops(apiShops));
    })
    .catch(function () {
      renderShops(SEED_SHOPS);
    });
})();
